import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import { ReactComponent as NoAccessSvg } from '#/static/NoAccess.svg';
import React from 'react';
import useSession from '#/common/hooks/useSession';
import { Navigate } from 'react-router-dom';
import ErrorPage from './ErrorPage';

const NoAccess: React.FC = () => {
  const { loading, error } = useSession();
  const { isDesktop } = useViewport();

  // If access is restored (for example after refresh), leave the no-access page.
  if (!loading && !error) {
    return <Navigate to="/dashboard" replace />;
  }

  const toTraneCloud = () => {
    globalThis.location.href = 'https://tranecloud.com/';
  };

  return (
    <NuvoBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      backgroundColor={color('primary', 'light2')}>
      <NuvoBox
        display="flex"
        width={isDesktop ? '33vw' : '90vw'}>
        <ErrorPage
          svg={NoAccessSvg}
          message="This user does not have access to TMM, please contact your administrator."
          buttonLabel="Back to Trane Cloud"
          onButtonClick={toTraneCloud}
        />
      </NuvoBox>
    </NuvoBox>
  );
};

export default React.memo(NoAccess);
